import { securityImage } from "assets";
import { Modal } from "components";
import { Link } from "react-router-dom";
import { Routes } from "router";

interface ResetSuccessfulModalPropsProps {
  show: boolean;
  close: () => void;
}

const ResetSuccessfulModal: React.FC<ResetSuccessfulModalPropsProps> = ({
  show,
  close,
}) => {
  return (
    <>
      <Modal
        position={"centered"}
        close={close}
        show={show}
        contentClassName='bg-white !overflow-visible !max-w-[410px]'
      >
        <div className="flex justify-center mb-6">
          <div className={`w-[130px] h-[130px] -mt-[80px] rounded-full grid place-content-center overflow-hidden`}>
            <img src={securityImage} alt="icon " className={`object-cover h-[150px] rounded-full object-[58%_center]`} />
          </div>
        </div>

        <h2 className={`text-3xl font-bold text-center mb-4 text-[#012169]`}>
          Congratulations
        </h2>

        <p className={`text-center mb-8 w-[70%] mx-auto text-[#344054]`}>
          Your password reset was successful
        </p>

        {/* Buttons */}
        <div className="flex gap-5 w-[80%] mx-auto mb-6">
          <Link
            to={Routes.signin}
            className={`flex-1 h-fit w-fit py-3 px-6 rounded-[4px] font-medium transition-colors bg-[#012169] hover:bg-[#012169]/60 text-white text-center`}
          >
            Login To Dashboard
          </Link>
        </div>
      </Modal>
    </>
  );
};

export { ResetSuccessfulModal };
